<template>
  {{ $t("labels.save") }}
  <span class="amount">{{ formatPrice(diff) }}</span>
  <span class="currency">&euro;</span>
</template>

<script>
import Price from "@/services/price";

export default {
  name: "CartTableUpsellDiff",
  props: {
    cartItemChoice: {
      type: Object,
    },
    upsellChoice: {
      type: Object,
    },
  },
  computed: {
    diff() {
      return this.cartItemChoice.unitPrice - this.upsellChoice.unitPrice;
    },
  },
  methods: {
    formatPrice(price) {
      // Retire les decimales nulles quel que soit le separateur de
      // locale (",00" en fr-FR, ".00" en en-US).
      return Price.format(price).replace(/[.,]00$/, "");
    },
  },
};
</script>
